import { Can } from '../../../../context/Ability';
import GiftPreview from '../common/GiftPreview';
import { Grid, useMediaQuery } from '@mui/material';
import { useSelector } from 'react-redux';
import { selectAllPreviousForms, selectShowAdminHistory } from '../../giftSlice';
import { useGetAllFormsQuery } from '../../giftApiSlice';
import FeedbackPreview from '../common/FeedbackPreview';
import AllPendingGift from './AllPendingGift';
import PreviousGift from '../common/PreviousGift';
import SwipeEdge from '../../../../common/SwipeEdge';

const ManageGiftHR = () => {
  useGetAllFormsQuery();
  const forms = useSelector(selectAllPreviousForms);
  const showHistory = useSelector(selectShowAdminHistory);
  const isMobile = useMediaQuery(theme => theme.breakpoints.down('lg'));
  return (
    <Can I='manage' this={'GiftForm'}>
      <Grid container sx={{ height: 'calc(100vh - 85px)', border: 0 }}>
        {showHistory ? <PreviousGift forms={forms} /> : <AllPendingGift />}
        {!isMobile && (
          <GiftPreview previewHeight='43vh'>
            <FeedbackPreview />
          </GiftPreview>
        )}
      </Grid>
      <SwipeEdge
        title={'GIFT preview'}
        content={
          <GiftPreview>
            <FeedbackPreview />
          </GiftPreview>
        }
        drawerBleeding={0}
      />
    </Can>
  );
};

export default ManageGiftHR;
